const locale = {
    placeholder: 'Vaxtı seç',
};
export default locale;
